import { getData, postData, putData, deleteData } from "../apiClient";

// get users with pagination
export const getRoomImagesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/room-image/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Room Images with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get room image data with id
export const getRoomImageWithId = async (id) => {
    try {
        const result = await getData(`/room-image/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Room Image data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// create room image
export const createRoomImage = async ({ data }) => {
    try {
        const result = await postData(
            `/room-image/add-room-image`,
            data,
            { "Content-Type": "multipart/form-data" }
        );

        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(
            "Room Image add API error:",
            error.status === 400 ? error.error : error.message
        );

        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data?.errors : error.message,
                status: error.status,
            },
        };
    }
};

// delete room image
export const deleteRoomImage = async ({ id }) => {
    try {
        const result = await deleteData(`/room-image/delete-room-image/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Delete Room Image API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// update room image data
export const updateRoomImage = async ({ id, data }) => {
    try {
        const result = await putData(`/room-image/update-room-image/${id}`, data, { "Content-Type": "multipart/form-data" });
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update Room Image API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
            },
        };
    }
};

export const getRoomList = async () => {
    try {
        const result = await getData(`/room-image/room-list`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Room List API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}